import TransactionDetails from './TransactionDetails';

export default TransactionDetails;
